import type { JSX } from 'react';

import { MetaArticleSchema } from './MetaArticleSchema';
import { MetaBreadcrumbSchema } from './MetaBreadcrumbSchema';
import { MetaDescriptionContainer } from './MetaDescription';
import { MetaHrefLangLink } from './MetaHrefLangLink';
import { MetaLocaleContainer } from './MetaLocale';
import { MetaOGContainer } from './MetaOG';
import { MetaRobotsContainer } from './MetaRobots';
import { MetaTypeContainer } from './MetaType';

export function MetaContainer(): JSX.Element | null {
	return (
		<>
			<MetaDescriptionContainer />
			<MetaTypeContainer />
			<MetaRobotsContainer />
			<MetaLocaleContainer />
			<MetaOGContainer />
			<MetaHrefLangLink />
			<MetaArticleSchema />
			<MetaBreadcrumbSchema />
		</>
	);
}
